import React from 'react';
import ImageTag from '../ImageTag/ImageTag';
import logo from '../Logo/logo.svg';

const BtSmLogo: React.FC = () => {
  return <ImageTag className="" src={logo} alt="Home" width="80" maxHeight="60" name={'Logo'} />;
};
export default BtSmLogo;
